import { render, staticRenderFns } from "./HcAlertItem.vue?vue&type=template&id=5fc5c0fc&scoped=true&"
import script from "./HcAlertItem.vue?vue&type=script&lang=js&"
export * from "./HcAlertItem.vue?vue&type=script&lang=js&"
import style0 from "./HcAlertItem.vue?vue&type=style&index=0&id=5fc5c0fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc5c0fc",
  null
  
)

export default component.exports